import React, { forwardRef } from 'react';
import "./styles.css"

const Footer = forwardRef((props, ref) => (
    <div id="Footer" ref={ref}>
        <div className={"leftFooter"}>
            <div className={'footerContactInfo'}>
                <h4 className={'footerHeader'}>Williams & Williams</h4>
                <a href={"tel:3019519525"}>(301) 951-9525</a>
                {/*<h4>(410) 412-3254</h4>*/}
                {/*<h4>(703) 592-9932</h4>*/}
                <h4>(202) 659-3768 (Fax)</h4>
                <h4><a
                    style={{color: 'black'}}
                    href={'mailto:office@williamslawgroup.com'}>office@williamslawgroup.com</a></h4>
                <h4>8630 Fenton Street
                    <br/>Montgomery Center, Suite 930
                    <br/>Silver Spring, Maryland
                    <br/>20910
                </h4>
            </div>
            <div className={'footerContactInfo'}>
                <h4 className={'footerSubHeader'}>Andrew Williams</h4>
                <a href={"tel:2022963320"}>(202) 296-3320</a>
                <h4><a
                    style={{color: 'black'}}
                    href={'mailto:Andrew@williamslawgroup.com'}>Andrew@williamslawgroup.com</a></h4>
            </div>
            <div className={'footerContactInfo'}>
                <h4 className={'footerSubHeader'}>Kevin Williams</h4>
                <a href={"tel:2022963320"}>(202) 296-3320</a>
                <h4><a
                    style={{color: 'black'}}
                    href={'mailto:Kevin@williamslawgroup.com'}>Kevin@williamslawgroup.com</a></h4>
            </div>
        </div>

        <div className={"rightFooter"}>
            <h4 className={'footerSubHeader'}>Hours</h4>
            <h4>Monday - Friday</h4>
            <h4>9:00am - 5:00pm</h4>
        </div>

        <hr className={'overfullHr'}/>
    </div>
));

export default Footer;